import type { DeepPartial } from '@luna/utils-ts';

import type { Orders } from '../../types/Orders';

export const ordersATFeatureConfig: DeepPartial<Orders> = {
    showOpenOrders: true,
    showPortfolioDropdown: true,
    stickyHeaderMobile: true,
    version: 1,
};
